import React from 'react';
import { Bars3BottomLeftIcon, ListBulletIcon, PhotoIcon, VideoCameraIcon, PlusIcon } from '@heroicons/react/24/outline';
import { TWButton } from '../../../components/ui';

// Image and Video need a saved note (media is stored under the note id).
// `locked` (an upload is in flight) disables every add button.
const AddBlockBar = ({ onAdd, mediaEnabled, locked = false }) => (
  <div className="flex flex-col gap-2 rounded-lg border border-dashed border-slate-300 p-3.5 dark:border-slate-600">
    <div className="flex flex-wrap items-center gap-2">
      <span className="mr-1 text-xs font-bold text-slate-500 dark:text-slate-400">Add</span>
      <TWButton size="sm" icon={PlusIcon} label="Heading" disabled={locked} onClick={() => onAdd('heading')} />
      <TWButton size="sm" icon={Bars3BottomLeftIcon} label="Paragraph" disabled={locked} onClick={() => onAdd('paragraph')} />
      <TWButton size="sm" icon={ListBulletIcon} label="List" disabled={locked} onClick={() => onAdd('list')} />
      <TWButton size="sm" icon={PhotoIcon} label="Image" disabled={locked || !mediaEnabled} onClick={() => onAdd('image')} />
      <TWButton size="sm" icon={VideoCameraIcon} label="Video" disabled={locked || !mediaEnabled} onClick={() => onAdd('video')} />
    </div>
    {!mediaEnabled ? (
      <p className="text-xs text-slate-500 dark:text-slate-400">Save the draft first to add images or videos.</p>
    ) : null}
  </div>
);

export default AddBlockBar;
